import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-money-euro-circle-fill",
  "use": "icon-money-euro-circle-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-money-euro-circle-fill\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1.95-11a2.5 2.5 0 0 1 4.064-1.41l1.701-1.133A4.5 4.5 0 0 0 8.028 11H7v2h1.027a4.5 4.5 0 0 0 7.788 2.543l-1.701-1.134A2.5 2.5 0 0 1 10.05 13l4.95.001v-2h-4.95z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol